<template>
  <div class="watch-video" ref="watchVideo">
    <shaka />
    <controls :canReturn="canReturn" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import faster from '@/faster'
import peanutbutterAPI from '@/api/peanutbutter'

let canReturn = false

function toggleScrollbar (show) {
  document.body.style.overflow = show ? 'auto' : 'hidden'
}

export default {
  name: 'watch-video',
  data: () => ({
    canReturn: false,
    timeUsage: 0,
    lastPlay: null
  }),
  watch: {
    fullscreen: 'toggleFullscreen',
    isVideoPlaying: 'videoPlaying',
    isVideoLoading: 'videoLoading',
    '$route.params.id': 'loadVideoData'
  },
  computed: {
    ...mapState({
      fullscreen: state => state.video.fullscreen,
      isVideoPlaying: state => state.video.playing,
      isVideoLoading: state => state.video.loading,
      userSubscriptionStatus: state => state.user.subscription.subscriptionStatus
    }),
    ...mapGetters({ findSegments: 'contentTree/findSegments' }),
    segmentId() {
      const segments = this.findSegments()
      return segments.find(it => it.playlistGroups.def.includes(this.playlistGroupId)).id
    },
    playlistGroupId() {
      return this.$route.params.playlistGroupId
    },
    playlistId() {
      return this.$route.params.playlistId
    },
    videoId() {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions({ loadVideo: 'video/load' }),
    ...mapMutations({ setFullscreen: 'video/SET_FULLSCREEN' }),
    toggleFullscreen(fullscreen) {
      if (fullscreen && !document.fullscreenElement) {
        this.$refs.watchVideo.requestFullscreen()
      } else if (!fullscreen && document.fullscreenElement) {
        document.exitFullscreen()
      }
    },
    loadVideoData(_, lastId) {
      if (lastId) {
        this.emitRevenueShare(lastId)
      }

      this.loadVideo({ id: this.videoId, playlistId: this.playlistId, playlistGroupId: this.playlistGroupId })
    },
    videoPlaying(isPlaying, wasPlaying) {
      this.updateTimeUsageState(isPlaying, wasPlaying)
    },
    videoLoading(isLoading, wasLoading) {
      this.updateTimeUsageState(!isLoading, !wasLoading)
    },
    updateTimeUsageState(isRunning, wasRunning) {
      const now = new Date().getTime()
      if (isRunning && !wasRunning) {
        this.lastPlay = now
      } else if (!isRunning && wasRunning) {
        if (this.lastPlay === null) {
          this.lastPlay = now
        }

        this.timeUsage += now - this.lastPlay
      }
    },
    emitRevenueShare(videoId) {
      this.updateTimeUsageState(!this.isVideoPlaying, this.isVideoPlaying)
      const timeUsage = (this.timeUsage / 1000).toFixed(3)

      peanutbutterAPI.emitPlayVideo(timeUsage, this.segmentId, videoId)
      faster.emit('play_video', {
        videoId: videoId,
        segmentId: this.segmentId,
        timeUsage: timeUsage.toString(),
        currentSubscriptionStatus: this.userSubscriptionStatus
      })

      this.timeUsage = 0
      this.lastPlay = null
    }
  },
  created() {
    toggleScrollbar()
    this.canReturn = canReturn
    this.loadVideoData()
  },
  mounted() {
    let fullscreenChanged = () => this.setFullscreen(!!document.fullscreenElement)
    this.$refs.watchVideo.addEventListener('webkitfullscreenchange', fullscreenChanged)
    this.$refs.watchVideo.addEventListener('mozfullscreenchange', fullscreenChanged)
    this.$refs.watchVideo.addEventListener('fullscreenchange', fullscreenChanged)
  },
  beforeRouteLeave(to, from, next) {
    this.emitRevenueShare(this.videoId)
    toggleScrollbar(1)
    next()
  },
  beforeRouteEnter(to, from, next) {
    toggleScrollbar()
    canReturn = from.name !== null
    next()
  }
}
</script>

<style lang="scss" scoped>
.watch-video {
  z-index: 10;
  height: 100vh;
}
</style>
